import * as React from 'react';

import {HelpButton} from 'shells/help/help-button';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {SectionLabel} from 'shells/typography/section-label';

import {PageContainer, PageTitleBar} from '../../layout';
import {useOpenableModal, OpenableModals} from '../../openable-modals';
import type {ReportURLParams} from '../../reports/report-types';

import {AnalyticsEmptyState} from './empty-state/analytics-empty-state';
import {SiteAnalyticsReport} from './report/analytics-report';
import {AnalyticsStatusButton} from './report/analytics-status/analytics-status-button';
import {useGetAnalyticsStatus} from './use-get-analytics-status';
import {VisitorsSummary} from './visitors-summary';

import styles from './analytics-page.module.css';

type Props = {
    onParamChange: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
};

export function AnalyticsPage(props: Props) {
    const {onOpen: onOpenAnalyticsModal} = useOpenableModal(
        OpenableModals.ANALYTICS_ONBOARDING_MODAL
    );

    const {analyticsStatus, isLoading} = useGetAnalyticsStatus();
    const status = analyticsStatus ? analyticsStatus.status : undefined;

    return (
        <PageContainer
            title='Analytics'
            pageTitleBar={
                <PageTitleBar
                    title='Analytics'
                    subheaderPrimaryText={
                        <div className='flex'>
                            Gain insights into your website traffic
                            {/* @ts-expect-error */}
                            <HelpButton onClick={onOpenAnalyticsModal} />
                        </div>
                    }
                    buttons={
                        <>
                            <AnalyticsStatusButton pageType='analytics' includeSeeAll={true} />
                        </>
                    }
                />
            }
        >
            {isLoading ? (
                <LoadingPage />
            ) : (
                <div className={styles['content-wrapper']}>
                    {analyticsStatus &&
                    (status === 'CONFIGURED' ||
                        status === 'NOT_WORKING' ||
                        status === 'NEW_VERSION_AVAILABLE') ? (
                        <>
                            <div>
                                <SectionLabel noBottomBorder={true}>Site visits</SectionLabel>
                                <SiteAnalyticsReport
                                    onParamChange={props.onParamChange}
                                    urlParams={props.urlParams}
                                    lastDetectedVisitTime={
                                        analyticsStatus.latestImpressionData
                                            ? analyticsStatus.latestImpressionData.createdTime
                                            : undefined
                                    }
                                />
                            </div>
                            <VisitorsSummary />
                        </>
                    ) : (
                        <AnalyticsEmptyState />
                    )}
                </div>
            )}
        </PageContainer>
    );
}
